import React, { useEffect, useState } from 'react'
import WithHOC from './actions'
import { Table, Typography, Button, Row, Col, Modal, Space, Input } from 'antd'
import LoadingOverlay from 'components/LoadingOverlay'
import { useTranslation } from "react-i18next";
import { Container } from 'react-bootstrap'

import {
  PlusOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
  EditTwoTone,
  DeleteTwoTone,
  SettingTwoTone,
  CheckCircleTwoTone,
  NotificationTwoTone,
  CloudSyncOutlined,
 } from '@ant-design/icons'

import { getItem } from 'utils/tokenStore'
import getWebsocketServer from 'utils/websocket'
import AddFirmwareModal from './AddFirmwareModal'
import EditFirmwareModal from './EditFirmwareModal'
import OtaStatusModal from './OtaStatusModal'

import _ from 'lodash';
import Paho from 'paho-mqtt'
import { requestSuccess } from 'utils/requestHandler'

let client = null
const INACTIVITY_THRESHOLD = 10000;

const Firmware = props => {
  const { t } = useTranslation();
  const { Title } = Typography

  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [otaStatusVisible, setOtaStatusVisible] = useState(false);

  const showAddModal = () => {
    setAddVisible(true);
  };

  const closeAddModal = () => {
    setAddVisible(false);
  };

  const showEditModal = () => {
    setEditVisible(true);
  };

  const closeEditModal = () => {
    setEditVisible(false);
    props.onChangeHOC('selectedFirmware', null);
    props.onChangeHOC('firmwareScope', null);
  };

  const showOtaStatusModal = () => {
    setOtaStatusVisible(true);
  };

  const closeOtaStatusModal = () => {
    setOtaStatusVisible(false);
    props.onChangeHOC('selectedFirmware', null);
    props.onChangeHOC('firmwareOtaStatus', null);
  };

  const columns = [ 
      { 
        key: "VERSION", 
        title: t("FirmwarePage.table.version"), 
        dataIndex: "VERSION",
        sorter: (a, b) => a.VERSION - b.VERSION, 
      }, 
      { 
        key: "DESCRIPTION", 
        title: t("FirmwarePage.table.description"), 
        dataIndex: "DESCRIPTION", 
      },
      
      {
        key: "UploadedTime",
        title: t("FirmwarePage.table.lastModified"),
        render: (_, firmware) => (
          <>{firmware.UPLOADED_TIME || '-'} </>
        ),
      },
      { 
        key: "ACT", 
        title: t("FirmwarePage.table.action"), 
        render: (_, firmware) => (
          <Space>
            <EditTwoTone onClick={() => {
              props.onChangeHOC('selectedFirmware', firmware);
              showEditModal();
            }} />
  
            <DeleteTwoTone onClick={() => 
              Modal.confirm({
                title: t("FirmwarePage.deleteFirmwareModal.title"),
                content: t("FirmwarePage.deleteFirmwareModal.content", { name: firmware.VERSION }),
                okText: t("Confirm"),
                cancelText: t("Cancel"),
                onOk: () => props.deleteFirmware(firmware.VERSION),
              })
            } />

            <CheckCircleTwoTone onClick={() => {
              Modal.confirm({
                title: t("FirmwarePage.pushFirmwareModal.title"),
                content: t("FirmwarePage.pushFirmwareModal.content", { name: firmware.VERSION }),
                okText: t("Confirm"),
                cancelText: t("Cancel"),
                onOk: () => props.pushFirmware(firmware.VERSION),
              })
            }} />

            <CloudSyncOutlined onClick={() => {
              props.onChangeHOC('selectedFirmware', firmware);
              showOtaStatusModal();
            }} />

            {/* <SettingTwoTone onClick={() => {
              props.onChangeHOC('selectedDevice', device);
              showConfigureModal();
            }} />
  
            
  
            <NotificationTwoTone onClick={() => {
              props.onChangeHOC('selectedDevice', device);
              showCheckDeviceDebugModal();
            }} /> */}
          </Space>
        ),
      },
    ];

    useEffect(() => {
            if (getItem("LOGIN_TOKEN")){
          props.getFirmwares()
          props.getDevices()
        }
        }, [])

	return (
		<Container>
      <Row style={{ alignItems: "center" }}>
        <Col sm={12}>
          <Title>{t("FirmwarePage.title")}</Title>
        </Col>
        <Col sm={12}>
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            style={{ background: "#1890ff", borderColor: "#1890ff", float: "right" }}
            onClick={showAddModal}
          >
            {t("FirmwarePage.addFirmware")}
          </Button>
        </Col>
      </Row>

      <Table
        dataSource={props.firmwares}
        columns={columns}
        rowKey={"Id"}
        pagination={{
        pageSizeOptions: ["10", "20", "50"],
        showSizeChanger: true,
        defaultPageSize: 10,
        showTotal: (total, range) =>
            t("pagination.showTotal", { start: range[0], end: range[1], total }),
        }}
    />

      {props.onLoading && <LoadingOverlay />}

      <AddFirmwareModal
        visible={addVisible}
        action={props.addFirmware}
        close={closeAddModal}
      />

      <EditFirmwareModal
        visible={editVisible}
        firmware={props.selectedFirmware}
        devices={props.devices}
        firmwareScope={props.firmwareScope}
        loadScope={props.getFirmwareScope}
        updateScope={props.updateFirmwareScope}
        close={closeEditModal}
      />

      <OtaStatusModal
        visible={otaStatusVisible}
        firmware={props.selectedFirmware}
        otaStatus={props.firmwareOtaStatus}
        loadStatus={props.getFirmwareOtaStatus}
        close={closeOtaStatusModal}
      />
    </Container>
	)
}

export default WithHOC(Firmware)